export const scanDeviceRoute = 'scan-your-device'
export const assignNameRoute = 'assign-a-name'
export const setupAccountRoute = 'setup-your-account'